import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.t52_1 = new (HttpStatusCode())(100, 'Continue');
        this.u52_1 = new (HttpStatusCode())(101, 'Switching Protocols');
        this.v52_1 = new (HttpStatusCode())(102, 'Processing');
        this.w52_1 = new (HttpStatusCode())(200, 'OK');
        this.x52_1 = new (HttpStatusCode())(201, 'Created');
        this.y52_1 = new (HttpStatusCode())(202, 'Accepted');
        this.z52_1 = new (HttpStatusCode())(203, 'Non-Authoritative Information');
        this.a53_1 = new (HttpStatusCode())(204, 'No Content');
        this.b53_1 = new (HttpStatusCode())(205, 'Reset Content');
        this.c53_1 = new (HttpStatusCode())(206, 'Partial Content');
        this.d53_1 = new (HttpStatusCode())(207, 'Multi-Status');
        this.e53_1 = new (HttpStatusCode())(300, 'Multiple Choices');
        this.f53_1 = new (HttpStatusCode())(301, 'Moved Permanently');
        this.g53_1 = new (HttpStatusCode())(302, 'Found');
        this.h53_1 = new (HttpStatusCode())(303, 'See Other');
        this.i53_1 = new (HttpStatusCode())(304, 'Not Modified');
        this.j53_1 = new (HttpStatusCode())(305, 'Use Proxy');
        this.k53_1 = new (HttpStatusCode())(306, 'Switch Proxy');
        this.l53_1 = new (HttpStatusCode())(307, 'Temporary Redirect');
        this.m53_1 = new (HttpStatusCode())(308, 'Permanent Redirect');
        this.n53_1 = new (HttpStatusCode())(400, 'Bad Request');
        this.o53_1 = new (HttpStatusCode())(401, 'Unauthorized');
        this.p53_1 = new (HttpStatusCode())(402, 'Payment Required');
        this.q53_1 = new (HttpStatusCode())(403, 'Forbidden');
        this.r53_1 = new (HttpStatusCode())(404, 'Not Found');
        this.s53_1 = new (HttpStatusCode())(405, 'Method Not Allowed');
        this.t53_1 = new (HttpStatusCode())(406, 'Not Acceptable');
        this.u53_1 = new (HttpStatusCode())(407, 'Proxy Authentication Required');
        this.v53_1 = new (HttpStatusCode())(408, 'Request Timeout');
        this.w53_1 = new (HttpStatusCode())(409, 'Conflict');
        this.x53_1 = new (HttpStatusCode())(410, 'Gone');
        this.y53_1 = new (HttpStatusCode())(411, 'Length Required');
        this.z53_1 = new (HttpStatusCode())(412, 'Precondition Failed');
        this.a54_1 = new (HttpStatusCode())(413, 'Payload Too Large');
        this.b54_1 = new (HttpStatusCode())(414, 'Request-URI Too Long');
        this.c54_1 = new (HttpStatusCode())(415, 'Unsupported Media Type');
        this.d54_1 = new (HttpStatusCode())(416, 'Requested Range Not Satisfiable');
        this.e54_1 = new (HttpStatusCode())(417, 'Expectation Failed');
        this.f54_1 = new (HttpStatusCode())(422, 'Unprocessable Entity');
        this.g54_1 = new (HttpStatusCode())(423, 'Locked');
        this.h54_1 = new (HttpStatusCode())(424, 'Failed Dependency');
        this.i54_1 = new (HttpStatusCode())(425, 'Too Early');
        this.j54_1 = new (HttpStatusCode())(426, 'Upgrade Required');
        this.k54_1 = new (HttpStatusCode())(429, 'Too Many Requests');
        this.l54_1 = new (HttpStatusCode())(431, 'Request Header Fields Too Large');
        this.m54_1 = new (HttpStatusCode())(500, 'Internal Server Error');
        this.n54_1 = new (HttpStatusCode())(501, 'Not Implemented');
        this.o54_1 = new (HttpStatusCode())(502, 'Bad Gateway');
        this.p54_1 = new (HttpStatusCode())(503, 'Service Unavailable');
        this.q54_1 = new (HttpStatusCode())(504, 'Gateway Timeout');
        this.r54_1 = new (HttpStatusCode())(505, 'HTTP Version Not Supported');
        this.s54_1 = new (HttpStatusCode())(506, 'Variant Also Negotiates');
        this.t54_1 = new (HttpStatusCode())(507, 'Insufficient Storage');
        this.u54_1 = allStatusCodes();
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = this.u54_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap().fc(capacity);
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var tmp$ret$2 = element.w54_1;
          destination.a5(tmp$ret$2, element);
        }
        tmp.v54_1 = destination;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpStatusCodeClass;
function HttpStatusCode() {
  if (HttpStatusCodeClass === VOID) {
    class $ {
      constructor(value, description) {
        Companion_getInstance();
        this.w54_1 = value;
        this.x54_1 = description;
      }
      toString() {
        return '' + this.w54_1 + ' ' + this.x54_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof HttpStatusCode()) {
          tmp = other.w54_1 === this.w54_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.w54_1;
      }
      y54(other) {
        return this.w54_1 - other.w54_1 | 0;
      }
      d(other) {
        return this.y54(other instanceof HttpStatusCode() ? other : THROW_CCE());
      }
    }
    initMetadataForClass($, 'HttpStatusCode', VOID, VOID, [Comparable()]);
    HttpStatusCodeClass = $;
  }
  return HttpStatusCodeClass;
}
function allStatusCodes() {
  return listOf([Companion_getInstance().t52_1, Companion_getInstance().u52_1, Companion_getInstance().v52_1, Companion_getInstance().w52_1, Companion_getInstance().x52_1, Companion_getInstance().y52_1, Companion_getInstance().z52_1, Companion_getInstance().a53_1, Companion_getInstance().b53_1, Companion_getInstance().c53_1, Companion_getInstance().d53_1, Companion_getInstance().e53_1, Companion_getInstance().f53_1, Companion_getInstance().g53_1, Companion_getInstance().h53_1, Companion_getInstance().i53_1, Companion_getInstance().j53_1, Companion_getInstance().k53_1, Companion_getInstance().l53_1, Companion_getInstance().m53_1, Companion_getInstance().n53_1, Companion_getInstance().o53_1, Companion_getInstance().p53_1, Companion_getInstance().q53_1, Companion_getInstance().r53_1, Companion_getInstance().s53_1, Companion_getInstance().t53_1, Companion_getInstance().u53_1, Companion_getInstance().v53_1, Companion_getInstance().w53_1, Companion_getInstance().x53_1, Companion_getInstance().y53_1, Companion_getInstance().z53_1, Companion_getInstance().a54_1, Companion_getInstance().b54_1, Companion_getInstance().c54_1, Companion_getInstance().d54_1, Companion_getInstance().e54_1, Companion_getInstance().f54_1, Companion_getInstance().g54_1, Companion_getInstance().h54_1, Companion_getInstance().i54_1, Companion_getInstance().j54_1, Companion_getInstance().k54_1, Companion_getInstance().l54_1, Companion_getInstance().m54_1, Companion_getInstance().n54_1, Companion_getInstance().o54_1, Companion_getInstance().p54_1, Companion_getInstance().q54_1, Companion_getInstance().r54_1, Companion_getInstance().s54_1, Companion_getInstance().t54_1]);
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance2192nrpo98q6y,
  HttpStatusCode as HttpStatusCode3o1wkms10pg4k,
};
//endregion

//# sourceMappingURL=HttpStatusCode.mjs.map
